import { useCallback, useEffect, useMemo, useState } from "react";
import { isMobile as reactIsMobile } from "react-device-detect";
import { debounce } from '../utils'

export type Size = {
    height: number,
    width: number
}


const heightLimit = 600;
const widthLimit = 481;

export default function UseMediaParams() {

    const [size, setSize] =
        useState<Size>({ height: window.innerHeight || 1, width: window.innerWidth || 1 });

    const setSizeFunc = useCallback(() => {
        setSize({ height: window.innerHeight, width: window.innerWidth });
    }, [])


    const [isMobile, setIsMobile] = useState(reactIsMobile);

    const debouncedHandleChange = useMemo(() => debounce(setSizeFunc, 300), [setSizeFunc]);

    window.addEventListener('resize', () => {
        debouncedHandleChange();
    })

    useEffect(() => {
        setIsMobile(
            (size.height < heightLimit || size.width < widthLimit));
    }, [size])



    return { isMobile, size };
}